<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport
      [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="(isHandset$ | async) ? 'over' : 'side'"
      [opened]="false">
    <mat-toolbar>Menu</mat-toolbar>
    <mat-nav-list>
     
      <a mat-list-item routerLink="/" (click)="drawer.close()">Inicio</a>
      <a mat-list-item routerLink="/virgen" (click)="drawer.close()">Virgen</a>
      <a mat-list-item routerLink="/novena" (click)="drawer.close()">Novena</a>
      <a mat-list-item routerLink="/romeria" (click)="drawer.close()">Romería</a>
      <a mat-list-item routerLink="/museo" (click)="drawer.close()">Museo</a>
      <a mat-list-item routerLink="https://lavirgendelanueva.etsy.com">Tienda</a>
      <a mat-list-item routerLink="/login" (click)="drawer.close()">Perfil</a>

      <theme-button></theme-button>

    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar>
      <button 
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">


        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span class="logo" routerLink="/">✝️ lavirgendelanueva</span>

      <span class="fill-space"></span>
      <div *ngIf="!(isHandset$ | async)">
        <a mat-button routerLink="/virgen">✨<span class="hide-text"> Virgen</span></a>
        <a mat-button routerLink="/novena">🙏<span class="hide-text"> Novena</span></a>
        <a mat-button routerLink="/romeria">💐<span class="hide-text"> Romería</span></a>
        <a mat-button routerLink="/museo">🏺<span class="hide-text"> Museo</span></a>
        <a mat-button href="https://lavirgendelanueva.etsy.com">🎁<span class="hide-text"> Tienda</span></a>
        <theme-button></theme-button>
        <a mat-button routerLink="/login" *ngIf="!(afAuth.authState | async)">🔑<span class="hide-text"> Accede</span></a>
        <a mat-button routerLink="/login" *ngIf="afAuth.authState | async as user">
          <img class="avatar" [src]="user.photoURL || 'assets/avatar.svg'"><span class="hide-text"> Perfil</span>
        </a>
      </div>

      <!--
      <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <a mat-menu-item href="">
          <i>💬</i>
          <span>Chat on Slack</span>
        </a>
        <a mat-menu-item href="">
          <i>💾</i>
          <span>Code on Github</span>
        </a>
      </mat-menu>
      -->

    </mat-toolbar>
    
    <!--<theme-button></theme-button> -->

    <ng-content></ng-content>

  </mat-sidenav-content>
  
</mat-sidenav-container>